import "./../App.css"

import { useEffect } from "react"
import Login from "../components/Authentication/Login"
import Logout from "../components/Authentication/Logout"
import Profile from "../components/user/Profile"
import Header from "../components/Header"

import { useUserAuth } from "../firebase/UserAuthContext"
import { db } from "../firebase/firebase_config"
import {
	doc,
	updateDoc,
	Timestamp,
	setDoc,
	getDocs,
	query,
	collection,
	where,
} from "firebase/firestore"

function SignInPage() {
	const { user } = useUserAuth()

	const user_Handler = async () => {
		if (user.uid) {
			try {
				//console.log(user)
				const userCol = collection(db, "Users")
				const q = query(userCol, where("uid", "==", user.uid))
				const q_snapshot = await getDocs(q)
				//console.log(q_snapshot)
				if (q_snapshot.docChanges().length > 0) {
					//User already exists on DB
					q_snapshot.forEach((doc) => {
						//console.log("User exists doc id: " + doc.id)
						//console.log("User exists: " + doc.data().displayName)
					})

					await updateDoc(doc(db, "Users", user.uid), {
						last_login: Timestamp.fromDate(new Date()),
						photoURL: user.photoURL,
					})

					//console.log("Succesfully updated login date")
				} else {
					//User does NOT exists on DB
					//console.log("User does not exists. Registering user...")
					registerUser()
				}
			} catch (error) {
				alert("Error retrieving user from firestore: ", error.message)
			}
		} else {
			//console.log("Not logged in")
		}
	}

	const registerUser = async () => {
		try {
			const userDoc = doc(db, "Users", user.uid)
			const user_data = {
				photoURL: user.photoURL,
				displayName: user.displayName,
				uid: user.uid,
				email: user.email,
				first_login: Timestamp.fromDate(new Date()),
				last_login: Timestamp.fromDate(new Date()),
				club: "",
				role: "Jugador",
				position: "",
				aletas: "",
				stick: "",
			}
			await setDoc(userDoc, user_data, { merge: true })
			//console.log("User succesfully registered!")
		} catch (error) {
			alert("Error registering new user into firestore Users: ", error.message)
		}
	}

	useEffect(() => {
		if (user) {
			//if user is logged in
			user_Handler()
		}
	}, [user])

	return (
		<div className="content">
			<Header title="Perfil" />

			{/* {error && <h1>Authentication Error</h1>} */}
			{!user && <Login></Login>}
			{user && (
				<div className="content">
					<Profile></Profile>
					<Logout></Logout>
				</div>
			)}
		</div>
	)
}

export default SignInPage
